export default {
	title: "Vigilancia",
	url: "vigilancia",
	subtitle: "Informe de vigilancia estratégica generado mediante búsqueda anonimizada: el tema del proyecto se neutraliza antes de cualquier consulta a fuentes públicas. El informe cubre el contexto macro (PESTEL), sectorial (5 fuerzas de Porter) e interno, con señales fuertes y débiles.",
	current: "Informe actual",
	archive: "Archivos",
	context_tab: "Contexto",
	empty: "Aún no hay informe de vigilancia para este proyecto.",
	generated_on: "Emitido el",
	actions: {
		generate: "Generar un informe",
		generate_new: "Generar un nuevo informe",
		generating: "Generando… (unos diez minutos)",
		retry: "Reintentar",
		print: "Imprimir",
		delete: "Eliminar este informe",
		delete_confirm: "¿Eliminar definitivamente este informe?"
	},
	steps: {
		anonymizing: "Anonimización del tema",
		researching: "Investigación y redacción",
		done: "Informe disponible",
		elapsed: "desde hace {{minutes}} min"
	},
	messages: {
		failed: "La generación falló",
		neutral_subject: "Tema anonimizado enviado",
		confirm_title: "¿Lanzar una vigilancia anonimizada?",
		confirm_body: "El tema del proyecto será anonimizado antes de cualquier búsqueda en fuentes públicas. La generación del informe tarda unos diez minutos."
	}
};
